import { Injectable } from '@angular/core';
import { JeevesModalService } from 'gung-standard-jeeves';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RefJeevesAddCustomerModalComponent } from '../../components/ref-jeeves-add-customer-modal/ref-jeeves-add-customer-modal.component';
import { RefMessageModalComponent } from '../../components/ref-message-modal/ref-message-modal.component';
import { Customer } from 'gung-standard';
import { RefJeevesEditCustomerModalComponent } from '../../components/ref-jeeves-edit-customer-modal/ref-jeeves-edit-customer-modal.component';

@Injectable({
  providedIn: 'root'
})
export class RefJeevesModalService extends JeevesModalService {
  constructor(protected modalService: NgbModal) {
    super(modalService);
  }

  openAddCustomerModal() {
    this.modalRef = this.modalService.open(RefJeevesAddCustomerModalComponent, this.modalOptions);
    this.modalRef.result.then(
      result => {
        if (result) {
          const modalRef = this.modalService.open(RefMessageModalComponent);
          modalRef.componentInstance.message = 'CUSTOMER_CREATE_SUCCESS';
        }
      },
      reason => {}
    );
  }

  openEditCustomerModal(customer: Customer) {
    this.modalRef = this.modalService.open(RefJeevesAddCustomerModalComponent, this.modalOptions);
    this.modalRef.componentInstance.create = false;
    this.modalRef.componentInstance.customer = customer;
    this.modalRef.result.then(
      result => {
        if (result) {
          const modalRef = this.modalService.open(RefMessageModalComponent);
          modalRef.componentInstance.message = 'CUSTOMER_UPDATE_SUCCESS';
        }
      },
      reason => {}
    );
  }
}
